import { apiBaseUrl } from '../../components/core/globalVariables';

async function fetchMetricDataSummaryKey({
  id,
  keyMetric,
  timeseries_at,
  summary,
  kind,
  method,
  srid = 4326,
  feature_ids,
  globalRefs,
  globalState
}) {

  const setLoggedInToAPI =
    globalState.setLoggedInToAPI;

  const setIsLoading =
    globalState.setIsLoading;

  const setisMenuLoadClick =
    globalState.setisMenuLoadClick;

  try {

    const token =
      localStorage.getItem('token');

    if (!token) {
      throw new Error('No token in local storage');
    }

    const params = new URLSearchParams({
      kind,
      properties: keyMetric,
      timeseries_at: String(timeseries_at),
      method,
      summary,
      srid: String(srid)
    });

    const response = await fetch(
      `${apiBaseUrl}/api/maps/${id}/features/summary?${params.toString()}`,
      {
        method: 'POST',

        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },

        body: JSON.stringify({
          feature_ids
        }),

      }
    );

    if (!response.ok) {

      const errorText =
        await response.text();

      throw new Error(
        `Key metric summary request failed: ${response.status} ${errorText}`
      );

    }

    const geoJsonData =
      await response.json();

    // const timestamp = new Date().toISOString();
    // console.log(timestamp + " " + "✅ fetching Key metric data");

    return geoJsonData;

  } catch (error) {

    console.error(
      "❌ Error fetching metric data:",
      error
    );

    // setLoggedInToAPI(false);
    // setisMenuLoadClick(true);

    return null;

  }

}

export default fetchMetricDataSummaryKey;